import script from "./LaputaMain.vue?vue&type=script&setup=true&lang=js"
export * from "./LaputaMain.vue?vue&type=script&setup=true&lang=js"

import "./LaputaMain.vue?vue&type=style&index=0&id=7057d1f0&lang=css"

const __exports__ = script;

export default __exports__